import { render, staticRenderFns } from "./orgDetailDialog.vue?vue&type=template&id=36ce3fa2&scoped=true"
import script from "./orgDetailDialog.vue?vue&type=script&lang=js"
export * from "./orgDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./orgDetailDialog.vue?vue&type=style&index=0&id=36ce3fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce3fa2",
  null
  
)

export default component.exports